import { StationsInputMui } from '@app/components/stations/StationsInputMui';
import { useAppData } from '@app/core/app-data';
import { useToast } from '@app/core/notifications';
import { FragmentTagGroup } from '@app/core/types/stations';
import { zodResolver } from '@hookform/resolvers/zod';
import { Box } from '@mui/material';
import { useMemo, useState } from 'react';
import { FormContainer } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { apiClient } from '../../../../../api';
import { useOwnedStations } from '../../../../../core/stations/hooks/useOwnedStations';
import { TagGroupsFormContent } from './tag-groups/components/TagGroupsFormContent';
import { getSchema } from './tag-groups/types';

/** Station-scoped form to manage fragment tag groups (RHF + MUI). */
export function TagGroupsForm() {
  const { $t } = useIntl();
  const { notifySuccess } = useToast();
  const { refetchStations } = useAppData();
  const stations = useOwnedStations();
  const [station, setStation] = useState(stations[0]);
  const schema = useMemo(() => getSchema((msg) => $t(msg)), [$t]);

  const tagGroups: FragmentTagGroup[] = station.featuresConfig?.fragments?.tagGroups || [];

  return (
    <Box>
      <Box mb={3} maxWidth={400}>
        <StationsInputMui
          stations={stations}
          value={station}
          onChange={setStation}
          selectProps={{
            size: 'small',
          }}
        />
      </Box>

      <FormContainer
        key={station.id}
        defaultValues={{
          tagGroups,
        }}
        resolver={zodResolver(schema)}
        onSuccess={async (data) => {
          await apiClient.fragments.configUpdate(station.id, {
            tagGroups: data.tagGroups,
          });

          notifySuccess(
            $t(
              {
                id: 'admin.fragments.configUpdated',
                defaultMessage: 'Fragment configuration for {stationName} updated',
              },
              { stationName: station.name },
            ),
          );
          refetchStations();
        }}
      >
        <TagGroupsFormContent />
      </FormContainer>
    </Box>
  );
}
